/**
 * LOCKER-522 — Sentry's browser tracing adds `sentry-trace` and `baggage`
 * headers to every fetch whose URL contains a `tracePropagationTargets`
 * string, and this app's targets include `localhost`. Those headers turn the
 * Browser Print request into a non-simple CORS request; the agent rejects the
 * preflight ("Request header field sentry-trace is not allowed"), so the
 * console never reached the printer on QA.
 *
 * Each target keeps Sentry's substring semantics but never matches the
 * Browser Print agent's origins.
 */
const BROWSER_PRINT_ORIGIN = String.raw`https?://(?:localhost|127\.0\.0\.1):910[01](?:/|$)`

const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")

export const excludeBrowserPrintFromTraceTargets = (
  targets: string[],
): RegExp[] =>
  targets.map(
    (target) =>
      new RegExp(`^(?!${BROWSER_PRINT_ORIGIN}).*${escapeRegExp(target)}`),
  )
